export const kamon_addresses = {
  decoderAddress:"0xAa37fA6cEb855500E269513cA9e6E5F13B4D0D95",
  kamonAddress:"0x31AF158f7350377B12849C69BfE34865c55710c7"
}
